var styleObj = {};
import createStyleSheet from "If_AdTool/common/createStyleSheet";
import UiTool from "If_AdTool/common/UiTool";
import Event from "If_AdTool/common/event";
import SendUrls from "If_AdTool/common/sendUrl";

function feedTW(adData,el) {
    if(adData.hasOwnProperty("extCode")&&adData.extCode){
        for(let key in adData.extCode){
            adData[key] = adData.extCode[key];
        }
    }
    let { 
        title, 
        desc,//描述
        adTag=1,
        img,
        curl,
        clktk,
        imptk,
        adlogo,
        style,
        cName,
        source ="",//来源
        time = "",//创意创建的时间
        prompt =""//交互提示语
    } = adData;
    if (source=="${SOURCE}"){
        source ="";
    }
    if (time == "${AD_CREATE_TIME}") {
        time = "";
    }
    if (prompt == "${JUMP_TIPS}") {
        prompt = "";
    }
    if(!styleObj.hasOwnProperty(cName)){
        styleObj[cName] = cName + '-' + window.IfengAmgr.uuid();
        style += `.clear-feedTW{
                zoom: 1;
            }
            .clear-feedTW:after {
                clear: both;
                content: "";
                display: block;
                height: 0;
            }
            .clear-feedTW a{
                display: block;
                float: right; 
                margin-right: 10px;
                padding-left: 27px;
                *position: relative;
                color:#999;
                font-size:12px;
                text-decoration:none;
            }
             .clear-feedTW:hover a{
                color: #ff2f42;
            }
            `
        style = style.replace(new RegExp(cName,"g"),styleObj[cName]);
        createStyleSheet(style);
        console.log("创建样式",cName)
    }
    let className = styleObj[cName];
    let imgcontainer = 'imgcontainer-' + window.IfengAmgr.uuid();
    // let content = adTag == 1 ? '<div class="' + className + '"><a href="' + curl + '" class="pic-' + className + '" id="' + imgcontainer + '" target="blank"><img src="' + img + '"></a><div class="text-' + className + '"><h2><a href="' + curl + '" target="blank">' + title + '</a></h2><p>' + desc + '</p></div><img src="' + adlogo + '" class="adlogo-' + className +'" style="opacity: .8;transform: scale(.8);"></div>':'<div class="'+className+'"><a href="'+curl+'" class="pic-'+className+'" id="'+imgcontainer+'" target="blank"><img src="'+img+'"></a><div class="text-'+className+'"><h2><a href="'+curl+'" target="blank">'+title+'</a></h2><p>'+desc+'</p></div></div>';
    let adElCnt = adTag == 1 ?`<img src="${adlogo}" class="adlogo-${className}" style="opacity: .8;transform: scale(.8);">`:"";
    let descCnt = `<div class="clear-${className}">
            <span style="margin-right:10px;color:#999;font-size:12px;display:${source?"inline-block":"none"};">${source}</span>
            <time style="margin-right:10px;color:#999;font-size:12px;display:${time?"inline-block":"none"};">今天 ${time}</time>
            <a style="display: block;float: right; margin-right: 10px;padding-left: 27px;*position: relative;" >${prompt}</a>
            </div>`
    let content = `<div class="${className}">
                        <a href="${curl}" class="pic-${className}" id="${imgcontainer}" target="blank">
                                <img src="${img}">
                        </a>
                        <div class="text-${className}">
                            <h2>
                                <a href="${curl}" target="blank">${title}</a>
                            </h2>
                            ${descCnt}
                            ${adElCnt}
                        </div>
                      
                    </div>`;
    el.innerHTML = content;
    UiTool.imgResize(imgcontainer,adData.img,3);
    SendUrls(imptk);
    let alist = el.getElementsByTagName("a");
    for (let i = 0; i < alist.length;i++){
        let a = alist[i];
        a.href = "javascript:;";
        a.target ="_self";
        a.onclick=function(){
           // return false;
        }

    }
    el.style.cursor = "pointer";
    Event.addEvent(el,"click",(e)=>{
        SendUrls(clktk);
        window.open(curl);
    })
}
if(typeof  window.IfengAmgr !=undefined){
    window.IfengAmgr.tplLib.twFeed = {render:feedTW,version:"1.0.1"};
}


